import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { Chip } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import { useElementTreeStore } from 'components/ElementsTree/ElementsTreeStore'
import { leftMostPaneStyles } from 'components/ElementsTree/styles/leftMostPaneStyles'
import { CategoryPanel } from 'models/category'
import { ElementPanelSubItem } from 'models/projectElements'
import {
    ADDED_TO_PROJECT,
    ALL_PROJECTS_ELEMENTS_TEXT,
} from 'pages/ProjectsPage/WorkspacePage/constants'
import React from 'react'
import { ElementsGroupToggle } from '../ElementsPanel/ElementsGroupToggle'

export type TogglePanelType = 'category' | 'elements'
export interface LeftMostPaneInnerContainerProps {
    contentTeamFromStudioPage?: boolean

    categoryNode?: React.ReactNode
    elementsNode?: React.ReactNode
    searchBar?: React.ReactNode
    handleChangeSelectGroupping?: (value: ElementPanelSubItem) => void
    selectedElementFilterType?: ElementPanelSubItem
    handleChangeFilterOption?: (value: ElementPanelSubItem) => void
    selectedCategory?: CategoryPanel | null
    outerPanelWidth?: number
    /** Callback invoked when a category is removed from filter pane. */
    handleResetCategories: VoidFunction
    isSearchInitiated?: boolean
}

export const LeftMostPaneInnerContainer = ({
    contentTeamFromStudioPage,
    categoryNode,
    elementsNode,
    searchBar,
    handleChangeSelectGroupping,
    selectedElementFilterType,
    handleChangeFilterOption,
    selectedCategory,
    outerPanelWidth = 0,
    handleResetCategories,
}: LeftMostPaneInnerContainerProps) => {
    const currentPane = useElementTreeStore((store) => store.currentPane)
    const showLeftMostPane = useElementTreeStore(
        (store) => store.showLeftMostPane
    )
    const classes = leftMostPaneStyles({
        showLeftMostPane,
        currentPane,
        outerPanelWidth: outerPanelWidth! - 40,
    })
    const addedToProjectSelected = React.useMemo(
        () => selectedElementFilterType?.value === ADDED_TO_PROJECT,
        [selectedElementFilterType]
    )

    const allCategoriesPanelSelected = React.useMemo(
        () => selectedCategory?.id === 'all',
        [selectedCategory]
    )
    return (
        <div className={classes.leftPaneInnerContainer}>
            {currentPane === 'category' && categoryNode}

            {currentPane === 'elements' && (
                <>
                    <ElementsGroupToggle
                        handleChangeSelectGroupping={
                            handleChangeSelectGroupping
                        }
                        selectedGrouppingType={selectedElementFilterType}
                        handleChangeFilterOption={handleChangeFilterOption}
                        searchBar={searchBar}
                    />

                    {!contentTeamFromStudioPage &&
                        (addedToProjectSelected ||
                            !allCategoriesPanelSelected) && (
                            <GridItem
                                className={classes.elementTypeFilterContainer}
                            >
                                {addedToProjectSelected && (
                                    <Chip
                                        label={selectedElementFilterType?.value}
                                        variant="outlined"
                                        className={classes.elementFilterChip}
                                        deleteIcon={<ClearIcon />}
                                        onDelete={(e) =>
                                            handleChangeFilterOption?.({
                                                ...selectedElementFilterType!,
                                                value: ALL_PROJECTS_ELEMENTS_TEXT,
                                            })
                                        }
                                    />
                                )}
                                {!allCategoriesPanelSelected && (
                                    <Chip
                                        label={selectedCategory?.name}
                                        data-testid={
                                            'category-' + selectedCategory?.name
                                        }
                                        variant="outlined"
                                        className={classes.elementFilterChip}
                                        deleteIcon={<ClearIcon />}
                                        onDelete={(e) =>
                                            handleResetCategories?.()
                                        }
                                    />
                                )}
                            </GridItem>
                        )}

                    {elementsNode}
                </>
            )}
        </div>
    )
}
